var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.56 6.50945L13.9886 0.618769C12.7886 -0.206256 11.1943 -0.206256 10.0114 0.618769L1.44 6.50945C0.531429 7.13647 0 8.1265 0 9.19904V22.3499C0 23.2575 0.771429 24 1.71429 24H8.57143V14.0997H15.4286V24H22.2857C23.2286 24 24 23.2575 24 22.3499V9.19904C24 8.1265 23.4686 7.13647 22.56 6.50945Z",
    fill: "#4909AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.659a6094fcb7c692f39992bb12796687.svg";
export { ForwardRef as ReactComponent };